import { render } from "./Testimonial1Content.vue?vue&type=template&id=2ff7a69b&scoped=true&ts=true"
import script from "./Testimonial1Content.vue?vue&type=script&lang=ts"
export * from "./Testimonial1Content.vue?vue&type=script&lang=ts"

import "./Testimonial1Content.vue?vue&type=style&index=0&id=2ff7a69b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff7a69b"]])

export default __exports__